import React from 'react';
import FilterReport from '../../../components/FilterReport';
import { EFilterItem } from '../../masterReport/types/report.type';
import TabPanelDoor from '../../report/components/charts/tabPanelDoor';

interface IProps {
  device: any;
}

const PanelDoorDataLog: React.FC<IProps> = ({ device }) => {
  return (
    <>
      <FilterReport
        init={Boolean(device.deviceId)}
        customDevice={device}
        hideFilters={[EFilterItem.company, EFilterItem.asset]}
      />
      <TabPanelDoor />
    </>
  );
};

export default PanelDoorDataLog;
